import clsx from "clsx";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CloseIcon, InfoIcon } from "../../../../assets/Icons";
import { createOfflineRemitter } from "../../../../services/offline";
import { offlineFlywire } from "../../../../store";
import Button from "../../../../components/ui/Button";

export const OfflineFlywireRemitterPage = () => {
  const fieldStyle = "text-black text-[18px] font-ssp font-semibold";
  const inputStyle = "mx-5 my-3 px-5 py-3 rounded-md border-2 border-gray-300 bg-blue-100";
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [bankName, setBankName] = useState<string>("");
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [secondaryId, setSecondaryId] = useState<string>("");
  const [panNumber, setPanNumber] = useState<string>("");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [primaryFile, setPrimaryFile] = useState<any>();
  const [documentType, setDocumentType] = useState<string>("");
  const [secondaryFile, setSecondaryFile] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [offlineFlywireData, setOfflineFlywireData] = useRecoilState(offlineFlywire);
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";
  const disableCondition =
    name === "" ||
    address === "" ||
    panNumber === "" ||
    secondaryId === "" ||
    primaryFile === null ||
    secondaryFile === null ||
    documentType === "";

  const handleNext = () => {
    setIsDisabled(true);
    setOfflineFlywireData({
      ...offlineFlywireData,
      bankAccountNumber: accountNumber,
    });
    const data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("phoneNumber", mobile);
    data.append("accNo", accountNumber);
    data.append("address", address);
    data.append("primaryDoc", primaryFile);
    data.append("primaryDocType", "PAN_CARD");
    data.append("primaryDocNo", panNumber);
    data.append("secondaryDoc", secondaryFile);
    data.append("secondaryDocType", documentType);
    data.append("secondaryDocNo", secondaryId);
    data.append("typeOfRemitter", "Flywire");
    createOfflineRemitter(currentUser, data)
      .then((res) => {
        navigate("/3/documents");
        localStorage.setItem("offlineRemitter", JSON.stringify(res?.data));
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage(error?.response?.data?.error?.type);
      })
      .finally(() => setIsDisabled(false));
  };

  const handleNameChange = (event: any) => {
    const result = event.target.value.replace(/[^a-z\s]/gi, "");
    setName(result);
  };

  return (
    <div>
      <div id="wrapper" className="flex flex-col items-center">
        <div
          id="topBanner"
          onClick={() => navigate("/home")}
          className="p-6 ml-[1430px] mt-2 hover:scale-150 cursor-pointer transition-all"
        >
          <CloseIcon />
        </div>
        <div id="body" className="flex w-full px-5 mt-10">
          <div id="remitterDetails" className="flex flex-col w-1/2 px-5 mr-2 border-r-2">
            <span className="font-bold text-[35px]">
              Remitter Details <span className="text-red-100 font-bold text-[35px]">*</span>
            </span>
            <div id="fields" className="flex flex-col px-10 mt-12 space-y-5">
              <div id="name" className="flex flex-col">
                <span className={fieldStyle}>Name</span>
                <input
                  value={name}
                  onChange={handleNameChange}
                  placeholder="Enter Name"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="email" className="flex flex-col">
                <span className={fieldStyle}>Email</span>
                <input
                  value={email}
                  onChange={(e: any) => setEmail(e.target.value)}
                  placeholder="Enter Email ID"
                  className={inputStyle}
                  autoComplete="off"
                />
              </div>
              <div id="mobile" className="flex flex-col">
                <span className={fieldStyle}>Mobile Number</span>
                <input
                  value={mobile}
                  onChange={(e: any) => setMobile(e.target.value)}
                  placeholder="Enter Mobile No."
                  className={inputStyle}
                />
              </div>
              <div id="bankName" className="flex flex-col">
                <span className={fieldStyle}>Bank Name</span>
                <input
                  value={bankName}
                  onChange={(e: any) => {
                    setBankName(e.target.value);
                    setOfflineFlywireData({ ...offlineFlywireData, bankName: e.target.value });
                  }}
                  placeholder="Enter Bank Name"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="accNo" className="flex flex-col">
                <span className={fieldStyle}>Account Number</span>
                <input
                  value={accountNumber}
                  onChange={(e: any) => {
                    setAccountNumber(e.target.value);
                    setOfflineFlywireData({
                      ...offlineFlywireData,
                      bankAccountNumber: e.target.value,
                    });
                  }}
                  placeholder="Enter Acc. No."
                  className={inputStyle}
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="address" className="flex flex-col">
                <span className={fieldStyle}>Permanent Address</span>
                <input
                  value={address}
                  onChange={(e: any) => setAddress(e.target.value)}
                  placeholder="Enter Address"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
            </div>
          </div>
          <div id="remitterKYC" className="flex flex-col w-1/2 px-5">
            <span className="font-bold text-[35px]">
              KYC Of Remitter<span className="text-red-100 font-bold text-[35px]">*</span>
            </span>
            <div
              id="panNu"
              className="flex items-center justify-between px-5 mt-12 border border-gray-400 rounded-xl"
            >
              <span className="font-semibold font-ssp text-[22px]">Enter PAN No.</span>
              <input
                value={panNumber}
                onChange={(e: any) => setPanNumber(e.target.value)}
                placeholder="Enter PAN Number"
                className="px-5 py-3 mx-5 my-3 bg-blue-100 border-2 border-gray-300 w-[400px] rounded-lg"
                autoComplete="off"
                pattern={specialCharRegExp}
              />
            </div>
            <div
              id="panBox"
              className="flex items-center justify-between px-5 py-4 mt-5 border border-gray-400 rounded-xl"
            >
              <div className="flex items-center space-x-10">
                <span className="font-semibold font-ssp text-[22px]">PAN Card</span>
                <span className="px-3 py-1 bg-yellow-300 rounded-md shadow-xl font-ssp">
                  Mandatory
                </span>
              </div>
              <form encType="multipart/form-data" action="">
                <div>
                  <input
                    accept="/*"
                    type="file"
                    onChange={(e: any) => setPrimaryFile(e.target.files[0])}
                  />
                </div>
              </form>
            </div>
            <span className="text-[16px] font-semibold font-ssp mt-12 ml-[230px]">
              AND ANY ONE OF THE FOLLOWING
            </span>
            <div
              id="otherDocBox"
              className="flex flex-col items-center justify-between px-5 py-4 mt-12 space-y-8 border border-gray-400 rounded-xl"
            >
              <div
                onClick={() => setDocumentType("AADHAR_CARD")}
                id="aadhaar"
                className="flex items-center justify-between w-full"
              >
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">Aadhaar Card</span>
                </div>
                <form encType="multipart/form-data" action="">
                  <div>
                    <input
                      accept="/*"
                      type="file"
                      onChange={(e: any) => setSecondaryFile(e.target.files[0])}
                    />
                  </div>
                </form>
              </div>
              <div
                onClick={() => setDocumentType("DRIVING_LICENCE")}
                id="dl"
                className="flex items-center justify-between w-full"
              >
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">Driving License</span>
                </div>
                <form encType="multipart/form-data" action="">
                  <div>
                    <input
                      accept="/*"
                      type="file"
                      onChange={(e: any) => setSecondaryFile(e.target.files[0])}
                    />
                  </div>
                </form>
              </div>
              <div
                onClick={() => setDocumentType("VOTER_CARD")}
                id="voterID"
                className="flex items-center justify-between w-full"
              >
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">Voter ID</span>
                </div>
                <form encType="multipart/form-data" action="">
                  <div>
                    <input
                      accept="/*"
                      type="file"
                      onChange={(e: any) => setSecondaryFile(e.target.files[0])}
                    />
                  </div>
                </form>
              </div>
              <div
                onClick={() => setDocumentType("PASSPORT_FRONT")}
                id="passport"
                className="flex items-center justify-between w-full"
              >
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">Passport</span>
                </div>
                <form encType="multipart/form-data" action="">
                  <div>
                    <input
                      accept="/*"
                      type="file"
                      onChange={(e: any) => setSecondaryFile(e.target.files[0])}
                    />
                  </div>
                </form>
              </div>
              {documentType && (
                <div
                  // id="panNu"
                  className="flex items-center justify-between px-5 mt-12 border border-gray-400 rounded-xl"
                >
                  <span className="font-semibold font-ssp text-[22px]">
                    Enter {documentType === "AADHAR_CARD" && "Aadhaar"}{" "}
                    {documentType === "DRIVING_LICENCE" && "Driving License"}{" "}
                    {documentType === "VOTER_CARD" && "VoterCard"}{" "}
                    {documentType === "PASSPORT_FRONT" && "Passport"} No.
                  </span>
                  <input
                    value={secondaryId}
                    onChange={(e: any) => setSecondaryId(e.target.value)}
                    className="px-5 py-3 mx-5 my-3 bg-blue-100 border-2 border-gray-300 w-[300px] rounded-lg"
                    autoComplete="off"
                    pattern={specialCharRegExp}
                  />
                </div>
              )}
            </div>
            <div id="note" className="flex mt-10 ml-2 space-x-4">
              <div>
                <InfoIcon />
              </div>
              <span className="font-bold text-gray-700">
                Please upload a self attested and agent attested copy of the KYC document
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center mt-10">
          <Button
            // disabled={isDisabled}
            isLoading={isDisabled}
            onClickHandler={handleNext}
            className={clsx(
              !disableCondition
                ? "px-10 py-4 font-bold text-white transition-all rounded-lg shadow-xl hover:bg-white hover:text-primary bg-primary hover:border-2 hover:border-primary cursor-pointer"
                : "px-10 py-4 font-bold text-white transition-all rounded-lg shadow-xl bg-gray-600"
            )}
          >
            Next
          </Button>
          <span className="mt-2 font-bold text-red-500">
            {errorMessage === "" ? "" : errorMessage}
          </span>
        </div>
      </div>
    </div>
  );
};
